import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _MILEAGE_STATUS_LABEL, _DAMAGE_STATUS_LABEL, _MILEAGE_KEY_VALUE_MA, _DISTANCE_VS_SPEED_UN;

import { MILEAGE_TYPE } from '../../utils/mileageLabelUtil';
export var MILEAGE_STATUS = {
  ACTUAL: 'ACTUAL',
  NOT_ACTUAL: 'NOT_ACTUAL',
  EXCEEDS_MECH_LIMITS: 'EXCEEDS_MECH_LIMITS'
};
export var MILEAGE_STATUS_LABELS = (_MILEAGE_STATUS_LABEL = {}, _defineProperty(_MILEAGE_STATUS_LABEL, MILEAGE_STATUS.ACTUAL, __('Actual')), _defineProperty(_MILEAGE_STATUS_LABEL, MILEAGE_STATUS.NOT_ACTUAL, __('Not Actual')), _defineProperty(_MILEAGE_STATUS_LABEL, MILEAGE_STATUS.EXCEEDS_MECH_LIMITS, __('Exceeds Mech. Limits')), _MILEAGE_STATUS_LABEL);
export var DAMAGE_STATUS = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  SERVICED: 'SERVICED'
};
export var DAMAGE_STATUS_LABEL = (_DAMAGE_STATUS_LABEL = {}, _defineProperty(_DAMAGE_STATUS_LABEL, DAMAGE_STATUS.OPEN, 'Open'), _defineProperty(_DAMAGE_STATUS_LABEL, DAMAGE_STATUS.IN_PROGRESS, 'In Progress'), _defineProperty(_DAMAGE_STATUS_LABEL, DAMAGE_STATUS.SERVICED, 'Serviced'), _DAMAGE_STATUS_LABEL);
export var MILEAGE_KEY_VALUE_MAP = (_MILEAGE_KEY_VALUE_MA = {}, _defineProperty(_MILEAGE_KEY_VALUE_MA, MILEAGE_TYPE.MILES, 'mile'), _defineProperty(_MILEAGE_KEY_VALUE_MA, MILEAGE_TYPE.KM, 'km'), _MILEAGE_KEY_VALUE_MA); // for dealerMaster values

export var DEALER_MILEAGE_MEASURE = {
  MILES: 'MILES',
  KILOMETERS: 'KILOMETERS'
};
export var MILEAGE_TYPE_UNIT = _defineProperty({}, MILEAGE_TYPE.MILES, __('mi'));
export var MAX_MILEAGE_VALUE = '2000000000';
export var INVALID_VIN_CHARS = ['I', 'O', 'Q', 'i', 'o', 'q'];
export var SPEED = {
  MPH: 'MPH',
  KMPH: 'KMPH'
};
export var DISTANCE_VS_SPEED_UNIT = (_DISTANCE_VS_SPEED_UN = {}, _defineProperty(_DISTANCE_VS_SPEED_UN, MILEAGE_TYPE.MILES, SPEED.MPH), _defineProperty(_DISTANCE_VS_SPEED_UN, MILEAGE_TYPE.KM, SPEED.KMPH), _DISTANCE_VS_SPEED_UN);
export { MILEAGE_TYPE };
export var TITLE_TYPE = {
  CLEAN: 'CLEAN',
  CLEAR: 'CLEAR',
  SALVAGE: 'SALVAGE',
  REBUILT: 'REBUILT',
  UNAVAILABLE: 'UNAVAILABLE'
};
export var TITLE_TYPE_OPTIONS = [{
  label: __('Clean'),
  value: TITLE_TYPE.CLEAN
}, {
  label: __('Clear'),
  value: TITLE_TYPE.CLEAR
}, {
  label: __('Salvage'),
  value: TITLE_TYPE.SALVAGE
}, {
  label: __('Rebuilt'),
  value: TITLE_TYPE.REBUILT
}, {
  label: __('Unavailable'),
  value: TITLE_TYPE.UNAVAILABLE
}];